/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

// Public surface — domain fetchers, domain types, error classes, and the
// canonical constants consumers commonly need. The generic Airtable client
// (`fetchAllAirtableRecords`, `AirtableRecord<TFields>`,
// `FetchAirtableRecordsOptions`) stays internal so consumers don't build
// ad-hoc Airtable-backed paths that bypass the domain layer. The
// `industry-map` and `url` helpers are also internal — they're tightly
// coupled to specific Airtable field semantics.
export { AirtableFirstPageError, AirtablePatMissingError } from "./client";
export type { AirtableFirstPageCause } from "./client";
export * from "./types";
// Named re-exports (no `export *`) — future helpers added inside these
// modules don't auto-become public surface. Widening requires an explicit
// addition here, which forces a major-bump conversation.
export { fetchAllGoldInstructors } from "./instructors";
export { fetchAllTrainingPartners } from "./training-partners";
export { fetchAllServicePartners, fetchServicePartnerBySlug } from "./service-partners";
export { DEFAULT_SPOTLIGHT_COUNT, getWeeklySpotlight } from "./spotlight";
// Generic URL normalizer — public because partner detail templates render the
// raw Airtable website link and need the same scheme-promotion the cards rely
// on. `slugify`/`joinDirectoryPath` stay internal (only the fetcher uses them).
export { normalizeWebsiteUrl } from "./url";
